module.exports = {
	"id": "/enet_event_status",
	"type": "object",
	"properties": {
		"eventId": {
			"type": "integer",
			"required": true
		},
		"tournamentId": {
			"type": "integer",
			"required": true
		},
		"sportId": {
			"type": "integer",
			"required": true
		},
		"homeId": {
			"type": "integer",
			"required": true
		},
		"awayId": {
			"type": "integer",
			"required": true
		},
		"statusFull": {
			"type": "string",
			"required": true
		},
		"statusType": {
			"type": "string",
			"required": true
		},
		"debug": {
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"created": {
					"type": "date-time"
				},
				"eventVersion": {
					"type": "integer"
				}
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/message_schemas/triggers/enet_event_status.json
 ** module id = 1827
 ** module chunks = 0
 **/